import React, { useEffect, useState } from "react";
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';
import EditableTable from "./GiveAwayTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import Swal from "sweetalert2";
import api from "../../../auth/api";
import { alertSuccess, alertError } from "../../../components/Alert";
import { fetchCountryList } from "@/slices/LocationSlice/countrySlice";
import AddGiveaway from "./AddGiveaway";
import { useSelector , useDispatch } from "react-redux";

export default function Giveaway() {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [changeLogData,setChangeLogData] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const itemsPerPage = 10;
  const editableFields = ['giveAway_id', 'title', 'link', 'body' , "country"];
  const [addDis, setAddDis] = useState(false);

  const { countryList, status } = useSelector((state) => state.countryList);


  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (status === 'idle') {
        dispatch(fetchCountryList());
      }
    }, [dispatch, status]);


  const fetchData = async () => {
    try {
      const response = await api.get("/redeem/panel/GiveAway");
      // console.log(response.data.result)
      setData(response.data.result);
      setChangeLogData(response.data.Change_Log)
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = data.find((item) => item.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
       const countryId = countryList?.result?.filter(f => f.title === editedData.country)[0]?.id;

    try {
      const finalData = {
        id:editedData.id,
        body:editedData.body,
        link:editedData.link,
        country: countryId,
        title:editedData.title,
        giveAway_id:editedData.giveAway_id
      }
      await api.patch(`/redeem/panel/GiveAway`,finalData);
      alertSuccess("Data updated successfully");
      setEditRowId(null);
      fetchData();
    } catch (error) {
      alertError(error.response.data.errors)
      console.error("Error updating data:", error);
    }

  };

  const handleAdd = async () => {
    setAddDis(true)
  };

  const handleLog = (id) => {
    const logData = changeLogData.filter((f) => f.id === id)[0]
      ?.oldTrack;
    // console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    setIsModalOpen(true)
  };



  const handleChange = (e, field, val) => {
    if (field === "is_active" || field === "editable" || field === "optional") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };
  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const headers = data.length > 0 ? Object.keys(data[0]).filter(key => key !== 'id') : [];

  const handleUploadImage = (row)=>{
    // console.log(row.id);
    alert(row.id)
  }

  if (loading) return <Loader />;

  return (
    <div className="w-full flex items-center flex-col">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        editableFields={editableFields}
        handleChange={handleChange}
        handleLog={handleLog}
        handleUploadImage={handleUploadImage}
        fetchData={fetchData}
        countryList={countryList?.result}
      />
      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
        <button className="activeBtn text-sm text-white py-1 px-2 rounded" onClick={handleAdd}>
          + Add Quick Poll
        </button>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Change Log" content={<ChangeLog data={currentLog} />} />


      <Modal isOpen={addDis} onClose={()=>setAddDis(false)} title="Add Quick Poll"  content={<AddGiveaway onSuccess={fetchData}  countryList={countryList?.result} onClose={()=>setAddDis(false)} />}/>
    </div>
  );
}
